var _circle, _rect, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _circle2, _g2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 274 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 211.794,
    cy: 64.9899,
    r: 23.443,
    fill: "#D9E8F2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 157.221,
    y: 15.9971,
    width: 116.245,
    height: 208.979,
    rx: 7.17884,
    fill: "#F4F6FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2043_10847)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 215.345,
    cy: 60.8376,
    r: 23.443,
    fill: "#D9E8F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.256 75.7502C199.295 70.4948 204.014 67.045 209.916 65.755C210.762 65.5701 211.114 64.2124 210.547 63.5579C208.624 61.3383 207.378 58.0687 207.378 55.4909C207.378 51.1682 210.882 47.6641 215.205 47.6641C219.527 47.6641 223.031 51.1682 223.031 55.4909C223.031 58.0519 221.801 61.2957 219.9 63.5143C219.336 64.1727 219.699 65.53 220.548 65.7067C226.556 66.9572 231.369 70.4275 233.434 75.7496C229.134 80.9594 222.627 84.2802 215.345 84.2802C208.062 84.2802 201.556 80.9597 197.256 75.7502Z",
    fill: "#BADDF4"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 203.081,
    y: 22.043,
    width: 26.792,
    height: 2.51175,
    rx: 1.25588,
    fill: "#C5CFD6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 173.014,
    y: 21.624,
    width: 3.349,
    height: 3.349,
    rx: 1.6745,
    fill: "#C5CFD6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 187.542,
    y: 98.3447,
    width: 55.6053,
    height: 3.349,
    rx: 1.6745,
    fill: "#D9E8F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 178.534,
    y: 105.429,
    width: 73.6193,
    height: 3.349,
    rx: 1.6745,
    fill: "#D9E8F2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 172.431,
    y: 129.587,
    width: 85.8268,
    height: 13.396,
    rx: 3.58942,
    fill: "#D9E8F2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 180.838,
    y: 135.029,
    width: 69.0128,
    height: 2.51175,
    rx: 1.25588,
    fill: "#BADDF4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 172.431,
    y: 153.358,
    width: 85.8268,
    height: 13.396,
    rx: 3.58942,
    fill: "#D9E8F2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 180.838,
    y: 158.802,
    width: 69.0128,
    height: 2.51175,
    rx: 1.25588,
    fill: "#BADDF4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 172.431,
    y: 177.132,
    width: 85.8268,
    height: 13.396,
    rx: 3.58942,
    fill: "#D9E8F2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 180.838,
    y: 182.573,
    width: 69.0128,
    height: 2.51175,
    rx: 1.25588,
    fill: "#BADDF4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.477,
    cy: 209.813,
    r: 8.37251,
    fill: "#E8ECF4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2043_10847)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6368 56.2345C101.334 58.3362 105.788 59.0835 107.741 58.3154C112.639 56.3892 110.83 37.8094 106.019 30.9876C101.209 24.1659 80.6985 23.4535 81.4608 38.0461C81.7254 43.1108 84.382 47.3334 87.9431 50.608L85.5597 77.3276L101.769 75.3373L96.6368 56.2345Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7259 24.2126C87.7867 24.0822 93.5684 23.617 95.7478 23.7054C98.7591 23.8279 104.541 25.6512 105.661 27.5265C106.782 29.4017 106.522 31.8949 102.822 32.128C99.6463 37.0502 94.6171 40.7736 93.9977 40.8998C93.9529 40.9089 91.1607 37.9507 89.053 39.5995C86.6095 41.5113 87.4571 44.381 89.163 46.4865L89.1845 46.5132C90.0756 47.6128 91.4118 49.2617 89.6994 50.8556C86.9745 53.3919 78.689 49.5134 76.9026 45.5447C73.5927 38.1915 75.6177 27.3727 83.8418 24.8139C85.2012 24.3909 86.048 24.2958 86.7259 24.2126Z",
    fill: "#384668"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.0674 133L115.993 218.978L127.717 283.532H139.484L127.738 133H91.0674Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.0674 133L115.993 218.978L127.717 283.532H139.484L127.738 133H91.0674Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.8657 133C81.6049 177.665 80.919 202.027 80.5297 206.085C80.1405 210.143 77.9306 237.321 62.8721 284.894H75.1109C95.0535 239.256 102.015 212.078 104.303 206.085C106.59 200.092 113.345 175.73 123.208 133H79.8657Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5327 133C97.0162 162.585 108.23 209.811 124.174 274.677H141.385C142.656 208.098 137.248 164.278 127.883 133H90.5327Z",
    fill: "#69A1AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7789 133C81.4823 177.665 77.068 221.669 63.394 275.373H81.7569C101.736 230.415 116.056 186.629 125.843 133H79.7789Z",
    fill: "#89C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1274 293.749L61.7485 283.725C61.7763 283.277 62.2124 282.97 62.6518 283.063C68.5474 284.304 76.6593 281.488 76.6593 281.488C84.8194 287.274 96.5718 289.94 100.763 290.747C101.59 290.906 102.118 291.74 101.888 292.55L100.97 295.792H76.6593H62.478L61.1274 293.749Z",
    fill: "#131B4B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.09 293.749L125.711 283.725C125.739 283.277 126.175 282.97 126.615 283.063C132.51 284.304 140.622 281.488 140.622 281.488C148.782 287.274 160.535 289.94 164.726 290.747C165.553 290.906 166.081 291.74 165.851 292.55L164.933 295.792H140.622H126.441L125.09 293.749Z",
    fill: "#131B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.377 144.817L128.704 149.062L91.4795 122.939C94.5271 109.225 103.365 83.821 114.337 91.9189C125.308 100.017 138.935 130.558 144.377 144.817Z",
    fill: "#E59900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.794 69.6574L174.071 56.0976C177.873 51.3302 181.646 47.606 185.389 44.9248C186.541 44.4077 188.571 44.0594 186.758 47.4904C184.944 50.9214 183.191 54.6118 184.19 55.6275C185.19 56.6432 187.571 55.1242 188.777 56.8238C189.581 57.9569 185.494 59.8889 176.517 62.6199L159.776 78.7855L150.794 69.6574Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.801 111.334L190.104 94.8451C195.949 93.1093 200.817 91.0095 204.707 88.5455C205.618 87.6716 206.703 85.9207 202.842 86.3145C198.981 86.7083 194.903 86.9488 194.336 85.6413C193.77 84.3339 196.071 82.6963 194.948 80.9411C194.199 79.771 190.875 82.8342 184.976 90.1308L163.71 99.5837L168.801 111.334Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4196 85.478L80.8352 79.6782C106.844 67.1665 143.683 73.3783 171.96 56.4785L176.727 65.5684C152.968 105.864 107.807 98.8091 79.4196 85.478Z",
    fill: "#FFA400"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3178 144.089C82.3178 144.089 117.169 137.943 133.589 135.048C135.932 134.635 134.893 131.326 134.253 129.677C126.867 110.645 107.861 92.0763 102.911 64.0031L87.7123 64.2894C78.9523 86.1397 78.9974 111.132 82.3178 144.089Z",
    fill: "#DDE3E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7932 83.4779C70.4213 87.963 75.9873 86.6548 80.5779 84.2893C75.0905 106.466 70.7272 135.541 73.409 160.183L119.561 152.045C121.538 142.386 117.644 126.359 112.253 110.593C116.715 112.688 121.871 114.875 127.816 117.096C147.322 124.384 169.469 114.794 181.609 102.235L181.717 91.07C169.906 95.7207 158.865 95.1691 148.02 94.6274C144.543 94.4537 141.087 94.2811 137.632 94.2811C121.103 88.7368 106.827 80.9614 98.3067 75.8119C95.0006 68.4813 92.6665 63.7842 92.6665 63.7842L87.7026 64.3701C87.364 64.3774 86.9964 64.4149 86.5979 64.4851C82.4552 65.2156 79.0034 65.0639 75.9615 64.9303C72.2453 64.767 69.1408 64.6305 66.1356 66.1623C60.6705 68.9478 59.6662 74.6676 66.7932 83.4779Z",
    fill: "#FFAA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.036 159.191C80.7777 151.389 82.382 142.358 83.8206 133.07C86.6326 142.523 90.191 151.888 94.1828 156.52L79.036 159.191Z",
    fill: "black",
    fillOpacity: 0.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0298 290.291L57.4162 282.995L52.6406 277.813L47.8656 277.397L46.1422 278.646C45.301 282.124 52.46 298.785 54.2201 299.584C55.6282 300.224 57.3705 300.074 58.0656 299.919C61.3357 297.965 58.9952 295.839 57.4162 295.019L55.0298 290.291Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4974 227.393C89.9534 226.965 87.1369 230.503 85.9217 232.326C83.52 231.211 78.6303 231.861 76.4856 232.326C74.1695 227.865 71.8034 227.608 70.9099 228.037C69.2799 230.181 70.2307 235.507 70.9099 237.902C68.6795 241.762 69.3372 246.73 69.9448 248.731L68.9798 251.734C65.2054 250.704 56.756 253.735 53.0032 255.379C49.4862 255.122 45.0327 257.059 43.2456 258.06L39.7072 256.773C36.2761 254.286 35.6327 245.944 35.7399 242.083L37.1337 227.393C37.4554 226.321 37.4126 224.069 34.6675 223.641C31.9225 223.212 31.8796 225.964 32.2013 227.393C31.701 230.181 30.4429 237.451 29.4135 244.228C28.3841 251.005 33.2022 260.491 35.7399 264.386C32.6303 270.927 36.0616 277.039 38.0988 279.398C39.7287 281.285 39.8502 284.044 39.7072 285.188L38.0988 286.582C37.5627 290.121 46.1408 306.097 47.9636 306.741C49.4219 307.255 51.1447 306.955 51.8237 306.741C54.9119 304.51 52.3956 302.595 50.7515 301.915L47.9636 297.412V294.624L51.2876 288.512C53.9683 287.547 56.6489 284.867 58.3645 283.044C59.737 281.585 60.2946 280.006 60.4018 279.398L62.4391 281.435L68.551 308.778C67.9434 309.35 67.0928 310.772 68.551 311.887C70.3739 313.281 74.234 313.174 75.8424 311.887C77.1291 310.858 75.6637 308.957 74.7701 308.135L72.9473 299.235V291.836L73.6979 287.547L74.7701 291.836L77.6652 306.097L79.1664 310.494L82.276 313.174C83.8844 313.603 87.2083 313.946 87.6372 311.887C88.1734 309.314 85.3855 308.135 84.0988 307.706C82.8121 307.277 81.7399 303.202 82.276 301.272C82.7049 299.728 83.6699 290.835 84.0988 286.582L86.4578 277.79C89.5673 274.466 88.8168 271.356 90.3179 267.603C91.5189 264.601 91.6046 261.205 91.4974 259.883C90.8898 258.203 90.3179 253.621 92.8913 248.731C95.4648 243.842 93.6062 238.616 92.3552 236.615C93.213 234.256 93.4275 227.93 91.4974 227.393Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.394 242.431V243.932",
    stroke: "black",
    strokeWidth: 0.446361
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8585 238.882C76.1809 239.06 75.6792 239.469 75.4302 239.781C75.3564 239.874 75.2215 239.889 75.1289 239.816C75.0362 239.742 75.0209 239.607 75.0947 239.514C75.3945 239.138 75.9722 238.672 76.7492 238.467C77.5347 238.26 78.5102 238.324 79.5841 238.992C79.6847 239.055 79.7155 239.187 79.6529 239.288C79.5903 239.388 79.4581 239.419 79.3575 239.357C78.3818 238.75 77.5275 238.706 76.8585 238.882Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3836 240.713C81.8395 239.34 80.1668 240.141 79.5234 240.713L80.6575 242.314C81.0017 242.8 81.7163 242.819 82.0859 242.352L83.3836 240.713Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.2733 239.604C86.1641 238.383 87.6923 239.085 88.1992 239.55C88.2864 239.63 88.4221 239.625 88.5022 239.537C88.5823 239.45 88.5765 239.314 88.4892 239.234C87.857 238.654 86.1157 237.904 84.0407 239.243C83.9412 239.308 83.9126 239.44 83.9768 239.54C84.0411 239.639 84.1738 239.668 84.2733 239.604Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2043_10847",
    x: 181.134,
    y: 30.2157,
    width: 68.4227,
    height: 68.4223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.58942
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.38413
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0548611 0 0 0 0 0.0934353 0 0 0 0 0.329167 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2043_10847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2043_10847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2043_10847",
    x: 0.380307,
    y: 0.217773,
    width: 211.315,
    height: 302.754,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.58942
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79471
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2043_10847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2043_10847",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.dea5777f5bddf0efd9ac1de1a1047fad.svg";
export { ForwardRef as ReactComponent };